import React from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';
import { CardFrame } from '../ui/card';

const Timeline = () => {
  const { t } = useTranslation();
  const titleRef = useScrollReveal();
  const timelineRef = useScrollReveal();

  // 연혁 데이터 - 추후 API로 대체 가능
  const milestones = [
    { date: t('about.timeline.milestone1.date'), title: t('about.timeline.milestone1.title'), desc: t('about.timeline.milestone1.desc') },
    { date: t('about.timeline.milestone2.date'), title: t('about.timeline.milestone2.title'), desc: t('about.timeline.milestone2.desc') },
    { date: t('about.timeline.milestone3.date'), title: t('about.timeline.milestone3.title'), desc: t('about.timeline.milestone3.desc') },
    { date: t('about.timeline.milestone4.date'), title: t('about.timeline.milestone4.title'), desc: t('about.timeline.milestone4.desc') },
  ];

  return (
    <section className="timeline-section">
      <div className="container">
        <h2 ref={titleRef} className="section-title scroll-reveal">{t('about.timeline.title')}</h2>
        <div ref={timelineRef} className="timeline scroll-reveal">
          {milestones.map((milestone, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-dot"></div>
              <CardFrame
                padding="1.5rem"
                radius="10px"
                shadow="normal"
                hover="md"
                className="timeline-content"
              >
                <div className="timeline-date">{milestone.date}</div>
                <h4>{milestone.title}</h4>
                <p>{milestone.desc}</p>
              </CardFrame>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Timeline;
